<section>
  <div class="wrapper">
    <article class="mrt-75">

      <div class="container-fluid max-height-scroll" style="margin-top: 20px;">
        <div class="header-main-div">
          <div class="ml-1 header-secondary-div">
            <h2 class="header-name">
              <mat-icon class="custom-icon-button users mr-1">people</mat-icon>
              <span>
                <a class="tag" routerLink="/cp/user-management">Users List</a>
              </span>
              <mat-icon class="chevron">chevron_right</mat-icon>
              <span>New Tips</span>
            </h2>
          </div>
          <div>
            <button mat-raised-button color="primary" (click)="addTip()">
              + Add New Tip
            </button>
          </div>
        </div>

        <ng-container *ngIf="dataSource.data.length > 0; else noDataTemplate">
          <div class="table-container um-table-wrap">
          <table mat-table [dataSource]="dataSource" matSort class="mat-table um-table">

            <ng-container matColumnDef="source">
              <th class="centered-sorted-header" mat-header-cell *matHeaderCellDef mat-sort-header>Source</th>
              <td class="centered-sorted-header" mat-cell *matCellDef="let t">{{ t.source }}</td>
            </ng-container>

            <ng-container matColumnDef="version">
              <th class="centered-sorted-header" mat-header-cell *matHeaderCellDef mat-sort-header>Version</th>
              <td class="centered-sorted-header" mat-cell *matCellDef="let t">{{ t.version }}</td>
            </ng-container>

            <ng-container matColumnDef="heading">
              <th class="left-sorted-header" mat-header-cell *matHeaderCellDef mat-sort-header>Heading</th>
              <td class="left-sorted-header" mat-cell *matCellDef="let t">{{ t.heading }}</td>
            </ng-container>

            <ng-container matColumnDef="short_desc">
              <th class="left-sorted-header" mat-header-cell *matHeaderCellDef>Short Desc.</th>
              <td class="left-sorted-header" mat-cell *matCellDef="let t">{{ t.short_desc }}</td>
            </ng-container>

            <ng-container matColumnDef="long_desc">
              <th class="left-sorted-header" mat-header-cell *matHeaderCellDef>Long Desc.</th>
              <td class="left-sorted-header" mat-cell *matCellDef="let t">{{ t.long_desc }}</td>
            </ng-container>

            <ng-container matColumnDef="action">
              <th class="centered-sorted-header" mat-header-cell *matHeaderCellDef>Action</th>
              <td class="centered-sorted-header" mat-cell *matCellDef="let t">
                <button mat-button (click)="editTip(t)">Edit</button>
                <button mat-button color="warn" (click)="openDeleteConfirmation(t.id)">
                  Delete
                </button>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
          <mat-paginator [length]="totalElements" [pageSize]="pageSize" [pageIndex]="pageIndex"
          [pageSizeOptions]="[5, 10, 25, 100]" showFirstLastButtons (page)="onPageChange($event)">
        </mat-paginator>
          </div>
        </ng-container>
        <ng-template #noDataTemplate>
          <div class="no-data">
            No tips available.
          </div>
        </ng-template>
      </div>
    </article>
  </div>
</section>